import { useState } from "react";
import { useSnapshot } from "valtio";
import { Agmongofile } from "../components/AgFile";
import TaskDatetime from "./task-datetime";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import { EntityV2Store } from "../state/CommonState";
import Utils from "../util/Utils";
import { DocumentRenderer, DocumentViewerWrapper } from "../mui-components/DocumentViewerWrapper";
import Api from "../state/Api";
import { loader } from "../util/loader";
let server = process.env.REACT_APP_FILE_SERVER

export default function Taskfiletable1(props) {
    useSnapshot(taskStore)
    const [newLabel, setNewLabel] = useState('')
    const [newInvoiceNo, setNewInvoiceNo] = useState('')
    const [newInvoiceDate, setNewInvoiceDate] = useState('')
    let creditCustomer = EntityV2Store.EntityRec.isCreditCustomer;
    let paymentTerms
    if(!taskStore.current.creditCustomer){
        taskStore.current.creditCustomer = EntityV2Store.EntityRec.isCreditCustomer
    }
    if(taskStore.current.creditCustomer == 'Yes'){
    paymentTerms = ['No Credit','As per Credit Facility Agreed','Custom']
    }else{
    paymentTerms = ['No Credit']
    }
    let documentLabel
    if (taskStore.current.actionName == 'Proforma Invoice Approval') {
        documentLabel = ['Proforma Invoice', 'Proforma Others Invoice']
    } else {
        documentLabel = ['Freight Invoice', 'Credit Note', 'Others Invoice']
        if (props.documentLabel) documentLabel.push('Custom Duties & Taxes Invoice')
    }
    const [newButtonEnabled, setNewButtonEnabled] = useState(false)
    let task = taskStore.current
    let docs
    if (taskStore.current.actionName === "Proforma Invoice Approval") {
        docs = task.files.filter(e => e.label !== "Supporting Document");
    } else {
        docs = task.files
    }    
    let removeadd = ["Carrier Release Order", "AWB Upload", "DO Release (Air)", "DO Release (Ocean)", "BL Draft Approval", "BL Upload", "Invoice Acceptance", 'Raise Invoice', 'Proforma Invoice Approval', 'Raise Proforma Invoice']
    if (!docs) docs = []
    return (
        <div>
            <table className="table is-striped is-fullwidth is-narrow" style={{ fontSize: '0.8rem' }}>
                <tr>
                    
                    <th>Document</th>
                    {docs.some(e => e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice') ? <th>Charge Description</th> : <th></th>}
                    {docs.some(e => e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice') ? <th>Payment Terms</th> : <th></th>}
                    {docs.some(e => (e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice') && e.paymentTerms === 'Custom') ? <th>Credit (1-45 Days)</th> : <th></th>}
                   {props?.additionalField?<th>Document No</th>:<th></th>} 
                   {props?.additionalField?<th>Document Date</th>:<th></th>}
                   <th>Link</th>
                   {props.insuranceCheck?<th>Cargo Value(USD)</th>:<th></th>}
                    {docs.some(e=>!e?.nonEditable)?<th>Upload</th>:<th></th>}
                    {
                        (props.showRejectReason) ?
                            <th>Reject Reason</th>
                            : <></>
                    }
                    {
                        (removeadd.indexOf(task.actionName)==-1)?<th></th>:<></>
                    }
                </tr>
                {
                    docs.map((e, index) => <tr style={{ padding: '0.5rem' }}>
                        {/* {
                        (removeadd.indexOf(task.actionName)==-1)?<td>
                                <p className="control" style={{ padding: '0px' }}>
                                    <button className="button is-success  is-inverted"
                                        onClick={() => {
                                            taskStore.current.files.splice(index+1, 0, {
                                                label: '',
                                                filename: '',
                                                ...(props?.additionalField ? { invoiceNo: '' } : {}), 
                                                ...(props?.additionalField ? { invoiceDate: '' } : {}),
                                                approved: '',
                                                rejectReason: ''
                                            })
                                        }}>
                                        <span className="icon is-small">
                                            <i className="fas fa-plus"></i>
                                        </span>
                                    </button>
                                </p>
                    </td>:<></>
                        } */}


                        {/* <td >{e.label}</td> */}
                        {/* {
                            props.showRejectReason?<td >{e.label}</td>: */}
                        {
                           props?.commercialInvoice?<td>
                            Commercial Invoice
                           </td>:
                           (task.actionName == 'Raise Invoice' || (task.actionName == "Proforma Invoice Approval" && task?.invoiceType) || (task.actionName == "Proforma Invoice Approval" && task.stage === 3) ?<td>{e.label}</td>: (e.approved=='Reject')?<td>{e.label}</td>:<td>
                           <div className="select">
                           <select value={e.label} onChange={(e)=>{
                               docs[index].label = e.target.value;
                               taskStore.currencyData[index].label = e.target.value;
                           }}>
                           <option value="">Select</option>
                               {documentLabel.map((e) =>
                                   <option  value={e}>
                                   {e}
                               </option>
                               )}
                           </select>
                           </div>
                       </td>)
                        }
                         {/* } */}
                        {e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice' ?<td>
                        <input value={e.chargeDescription} type="text" placeholder="Enter Description" className="input is-small" maxLength={100} onChange={(event)=> docs[index].chargeDescription  = event.target.value}/>
                        </td>:<td></td>}
                        {e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice' ?(e.approved=='Reject')?<td>{e.paymentTerms}</td>:<td>
                        <div className="select">
                           <select value={e.paymentTerms} onChange={(e)=>{
                               docs[index].paymentTerms = e.target.value;
                               if(e.target.value==='No Credit'||e.target.value==='As per Credit Facility Agreed') docs[index].creditDays=''
                           }}>
                           <option value="">Select</option>
                               {paymentTerms.map((e) =>
                                   <option  value={e}>
                                   {e}
                               </option>
                               )}
                           </select>
                           </div>
                        </td>:<td></td>}
                        {(e.label === 'Others Invoice' || e.label === 'Proforma Others Invoice') && e.paymentTerms === 'Custom'?<td>
                            <input value={e.creditDays} min={1} max={45}  placeholder="Enter Value 1-45Days"  onChange={(event)=>{
                            if(event.target.value >= 1 && event.target.value<= 45){
                                docs[index].creditDays = Utils.toNum(event.target.value);
                            }else{
                                docs[index].creditDays =""
                            }
                            }} className="input is-small" />
                           </td>:<td></td>}
                        {props?.additionalField?<td><input placeholder="Enter Invoice No" className={(props?.validation && (e.invoiceNo==undefined || e.invoiceNo.length==0))?"input is-small is-danger":"input is-small"}
                            value={e.invoiceNo} onChange={(e) => {
                                docs[index].invoiceNo = e.target.value
                                setNewInvoiceNo(e.target.value)
                            }} /></td>:<></>}
                        
                        {props?.additionalField?<td>
                            <input placeholder="Enter Invoice Date" type="date" className={(props?.validation && (e.invoiceDate==undefined || e.invoiceDate.length==0))?"input is-small is-danger":"input is-small"}
                            value={e.invoiceDate} onChange={(e) => {
                                docs[index].invoiceDate = e.target.value
                                setNewInvoiceDate(e.target.value)
                            }} /></td>
                        :<></>}
                        <td className={(props?.validation && (e.filename==undefined || e.filename.length==0))?"is-danger-border":""}>
                            {
                                (e.filename) ?<>
                                    <DocumentViewerWrapper>
                                        <DocumentRenderer render={(updateDocumentState)=>{
                                            return <>
                                              <a onClick={()=>{
                                                  updateDocumentState({documentViewUrl:server + '/api/v1/filestore/getfile/' + task.bookingNum + '/' + e.filename,documentTitle:e.filename,open:true})
                                              }} >
                                        {e.filename}
                                    </a>{
                                        (e.approved != 'Approve')?<>&nbsp;<button class="button is-danger" onClick={()=>e.filename=""}><i class="fa fa-trash" aria-hidden="true"></i></button></>:<></>
                                    }
                                            </>
                                        }} />
                                    </DocumentViewerWrapper>
                                     </> : <></>
                            }
                        </td>
                        {props.insuranceCheck?
                        <td>
                        <input placeholder="Enter Cargo Value" className={(props?.validation && (e.amount==undefined || e.amount.length==0))?"input is-small is-danger":"input is-small"}
                            value={e.amount} onChange={(e) => {
                                docs[index].amount = e.target.value
                                // setNewInvoiceDate(e.target.value)
                            }} />                        
                        </td>:<td></td>}
                        { !e?.nonEditable ?
                        <td id={e.label.replaceAll(" ","")+"___"+index} className={(props?.validation && (e.filename==undefined || e.filename.length==0))?"is-danger-border":""}>
                        {
                            (e.approved !== 'Approve') ?
                                <Agmongofile disabled={(e.approved === 'Approve') ? true : false} parent={e.label.replaceAll(" ","")+"___"+index}
                                    label={e.label} filekey={task.bookingNum}
                                    multiple={true}
                                    callback={async (data, id, uploadedFiles) => {
                                        console.log(id, data)
                                        const dataList = Array.isArray(data) ? data : [data]
                                        if (dataList.length === 0) return

                                        const targetIndex = taskStore.current.files.indexOf(docs[id])
                                        const actualIndex = targetIndex !== -1 ? targetIndex : id

                                        taskStore.current.files[actualIndex].filename = dataList[0]?.key?.filename || dataList[0]?.filename || ''

                                        if (dataList.length > 1) {
                                            const newRows = dataList.slice(1).map(item => ({
                                                label: docs[id].label,
                                                filename: item?.key?.filename || item?.filename || '',
                                                ...(props?.additionalField ? { invoiceNo: docs[id].invoiceNo || '' } : {}), 
                                                ...(props?.additionalField ? { invoiceDate: docs[id].invoiceDate || '' } : {}),
                                                approved: '',
                                                rejectReason: ''
                                            }))
                                            taskStore.current.files.splice(actualIndex + 1, 0, ...newRows)
                                        }

                                        const isInvoiceAction = task?.actionName?.includes('Invoice');
                                        if (isInvoiceAction && uploadedFiles && uploadedFiles[0]) {
                                            try {
                                                loader.show();
                                                const formData = new FormData();
                                                formData.append('file', uploadedFiles[0]);
                                                const url = `${process.env.REACT_APP_API_SERVER}/api/v1/ai/extract-invoice`;
                                                const res = await fetch(url, {
                                                    method: 'POST',
                                                    headers: Api.H1(),
                                                    credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
                                                    body: formData
                                                });
                                                const json = await res.json();
                                                if (json?.success && json?.data) {
                                                    const ocr = json.data;
                                                    if (ocr.documentNo) {
                                                        taskStore.current.files[actualIndex].invoiceNo = ocr.documentNo;
                                                        setNewInvoiceNo(ocr.documentNo);
                                                    }
                                                    if (ocr.documentDate) {
                                                        taskStore.current.files[actualIndex].invoiceDate = ocr.documentDate;
                                                        setNewInvoiceDate(ocr.documentDate);
                                                    }
                                                    if (!taskStore.currencyData) {
                                                        taskStore.currencyData = [];
                                                    }
                                                    if (!taskStore.currencyData[actualIndex]) {
                                                        taskStore.currencyData[actualIndex] = {
                                                            label: taskStore.current.files[actualIndex]?.label || '',
                                                            currencyType: '',
                                                            remarks: '',
                                                            netAmount: 0,
                                                            gstAmount: 0,
                                                            totalAmount: 0
                                                        };
                                                    }
                                                    if (taskStore.currencyData[actualIndex]) {
                                                        if (ocr.currencyType) {
                                                            taskStore.currencyData[actualIndex].currencyType = ocr.currencyType;
                                                        }
                                                        if (ocr.netInvoiceAmount !== '' && ocr.netInvoiceAmount != null) {
                                                            taskStore.currencyData[actualIndex].netAmount = String(ocr.netInvoiceAmount);
                                                        }
                                                        if (ocr.gstAmount !== '' && ocr.gstAmount != null) {
                                                            taskStore.currencyData[actualIndex].gstAmount = String(ocr.gstAmount);
                                                        }
                                                        if (ocr.totalAmount !== '' && ocr.totalAmount != null) {
                                                            taskStore.currencyData[actualIndex].totalAmount = String(ocr.totalAmount);
                                                        } else if (ocr.netInvoiceAmount || ocr.gstAmount) {
                                                            const net = parseFloat(ocr.netInvoiceAmount) || 0;
                                                            const gst = parseFloat(ocr.gstAmount) || 0;
                                                            taskStore.currencyData[actualIndex].totalAmount = Utils.toNum(net) + Utils.toNum(gst);
                                                        }
                                                    }
                                                }
                                            } catch (err) {
                                                console.error('OCR Extraction error:', err);
                                            } finally {
                                                loader.hide();
                                            }
                                        }
                                    }} />

                                : <></>
                        }
                    </td> :<td></td>

                        }
                        {
                            (props.showRejectReason) ?
                                <td>
                                    {
                                        (e.approved === 'Reject') ? e.rejectReason : ''
                                    }
                                </td>
                                : <></>
                        }
                        {
                            (removeadd.indexOf(task.actionName) == -1) ? <td>
                                <p className="control" key={index} style={{ padding: '0px' }}>
                                    {index === taskStore.current.files.length - 1 ? (<><button
                                        className="button is-success is-inverted"
                                        onClick={() => {
                                            if(props?.commercialInvoice){
                                                taskStore.current.files.splice(index + 1, 0, {
                                                    label: 'Commercial Invoice',
                                                    filename: '',
                                                    ...(props?.additionalField ? { invoiceNo: '' } : {}),
                                                    ...(props?.additionalField ? { invoiceDate: '' } : {}),
                                                    approved: '',
                                                    rejectReason: ''
                                                });
                                            }else{
                                                taskStore.currencyData.splice(index+1,0,{
                                                        label: '',
                                                        currencyType: "",
                                                        remarks: "",
                                                        netAmount: 0,
                                                        gstAmount: 0,
                                                        totalAmount: 0,
                                                      })
                                                taskStore.current.files.splice(index + 1, 0, {
                                                    label: '',
                                                    filename: '',
                                                    ...(props?.additionalField ? { invoiceNo: '' } : {}),
                                                    ...(props?.additionalField ? { invoiceDate: '' } : {}),
                                                    amount:'',
                                                    approved: '',
                                                    rejectReason: '',
                                                    chargeDescription: '',
                                                    paymentTerms: '',
                                                    creditDays: ''
                                                });
                                            }
                                        }}
                                    >
                                        <span className="icon is-small">
                                            <i className="fas fa-plus"></i>
                                        </span>
                                    </button>
                                    {taskStore.current.files.length !== 1?
                                    <button
                                    className="button is-danger is-inverted"
                                    onClick={() => {
                                        taskStore.current.files.splice(index, 1);
                                        taskStore.currencyData.splice(index, 1);
                                    }}
                                >
                                    <span className="icon is-small">
                                        <i className="fas fa-trash"></i>
                                    </span>
                                </button>:<></>}
                                    </>
                                    ) : (
                                        <button
                                            className="button is-danger is-inverted"
                                            onClick={() => {
                                                taskStore.current.files.splice(index, 1);
                                                taskStore.currencyData.splice(index, 1);
                                            }}
                                        >
                                            <span className="icon is-small">
                                                <i className="fas fa-trash"></i>
                                            </span>
                                        </button>
                                    )}
                                </p>
                            </td> : <></>
                        }
                    </tr>)
                }
                
                {/* {
                        (removeadd.indexOf(task.actionName)==-1)?<tr>
                        <td></td>
                        <td>
                            <input placeholder="Name for new Document" className="input is-small"
                                value={newLabel} onChange={(e) => {
                                    if (e.target.value.length > 0) setNewButtonEnabled(true)
                                    else setNewButtonEnabled(false)
                                    setNewLabel(e.target.value)
                                }} />
                        </td>
                        <td>
                            <button disabled={!newButtonEnabled} className="button is-small islink"
                                onClick={() => {
                                    taskStore.current.files.push({
                                        label: newLabel,
                                        filename: '',
                                        ...(props?.additionalField ? { invoiceNo: '' } : {}), 
                                        ...(props?.additionalField ? { invoiceDate: '' } : {}),
                                        approved: '',
                                        rejectReason: ''
                                    })
                                    setNewLabel('')
                                    setNewButtonEnabled(false)
                                }}>Add Document Type to Table</button>
                        </td>
                    </tr>:<></>
                } */}

            </table>
            <hr />
        </div>
    )
}